import { Circle, CircleYears } from '../types'
import { MAX_RADIUS_YEARS } from '../data'
import { formatPercentageUniversal, formatNumberRound } from '../../../lib/format-utils'
import { saveRestore } from '../../../lib/canvas-utils'

export function drawCircle(
  ctx: CanvasRenderingContext2D,
  circle: Circle,
  options: { strokeOpacity: number; fillOpacity: number }
) {
  const { x, y, radius, color } = circle
  const { strokeOpacity, fillOpacity } = options

  saveRestore(ctx, () => {
    ctx.strokeStyle = color
    ctx.fillStyle = color

    ctx.beginPath()
    ctx.arc(x, y, radius, 0, 2 * Math.PI)

    ctx.globalAlpha = fillOpacity
    ctx.fill()
    ctx.globalAlpha = strokeOpacity
    ctx.stroke()
  })
}

export function drawYearsLabel(ctx: CanvasRenderingContext2D, label: CircleYears) {
  const { x, y, year, opacity, color } = label

  ctx.globalAlpha = opacity

  const textYear = year.toString()

  const fontSize = 30

  ctx.fillStyle = color
  ctx.font = `bold ${fontSize}px rational`
  ctx.textBaseline = 'middle'
  ctx.textAlign = 'center'
  ctx.fillText(textYear, x, y)
}

export function drawYearsLegend(ctx: CanvasRenderingContext2D, label: CircleYears) {
  const { x, y, year, opacity, color, percentage, co2_mmt } = label

  ctx.globalAlpha = opacity

  const rectHeight = MAX_RADIUS_YEARS * 0.75

  const yearFontSize = 20
  const fontSize = 16

  const yYear = y - rectHeight / 2 + yearFontSize
  const yEmissions = yYear + fontSize * 1.5
  const yCo2 = yEmissions + fontSize * 1.5

  function drawYears() {
    const text = year.toString()

    ctx.fillStyle = color
    ctx.font = `bold ${yearFontSize}px rational`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(text, x, yYear)
  }

  function drawEmissions() {
    const text = `${formatPercentageUniversal(percentage, { significant: 3 })} of all emissions`

    ctx.font = `bold ${fontSize}px rational`
    ctx.fillStyle = 'black'
    ctx.fillText(text, x, yEmissions)
  }

  function drawCo2() {
    const text = `(${formatNumberRound(co2_mmt)} mmt CO₂)`

    ctx.font = `normal ${fontSize}px rational`
    ctx.fillText(text, x, yCo2)
  }

  drawYears()
  drawEmissions()
  drawCo2()
}
